import { render, staticRenderFns } from "./OrientationDialog.vue?vue&type=template&id=3084a3c7"
import script from "./OrientationDialog.vue?vue&type=script&lang=js"
export * from "./OrientationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.2_webpack@5.75.0__ejs@3.1.8_lodash@4.17.21_vue-template-compiler@2.7.14_webpack@5.75.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports